/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.123.3-v202604150000-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise } from 'axios';
import { getAxiosInstance, SeeqAxiosRequestConfig } from '@/requests/axios.utilities';
import { isNil, omitBy } from 'lodash';
import * as qs from 'qs';
import * as models from '../model/models';
import { APPSERVER_API_PREFIX } from '@/main/app.constants';

export class sqTablesApiClass {
 
   constructor() {}

  /**
   * @summary Export table data as CSV, respecting filters and sorts, up to the requested limit
   * @param {string} tableId - ID of the table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public exportTableDataCsv(
    body: models.TableDataQueryInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(tableId)) {
      throw new Error("'tableId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/tables/${encodeURIComponent(String(tableId))}/data/csv`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise;
  }

  /**
   * @summary Generate a condition table based on the table specified by id
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public queryConditionTable(
    body: models.ConditionTableInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/tables/condition`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.TableResultOutputV1>;
  }

  /**
   * @summary Query a simple table in which the rows are items and columns are item properties and formula statistics for those items.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public querySimpleTable(
    body: models.SimpleTableInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/tables/simple`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.TableResultOutputV1>;
  }

  /**
   * @summary Query table data with filters and advanced options
   * @param {string} tableId - ID of the table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public queryTableData(
    body: models.TableDataQueryInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(tableId)) {
      throw new Error("'tableId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/tables/${encodeURIComponent(String(tableId))}/data`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.TableResultOutputV1>;
  }

}


export const sqTablesApi = new sqTablesApiClass();
